module.exports = __webpack_public_path__ + "static/media/Souncloud.57428016.svg";